const CaseNotes = (() => {
  //--------------------------
  // SESSION DATA
  //--------------------------
  let caseNoteId = null;
  let caseNoteGroupId = null;
  let caseNoteEditData = null;
  let caseNoteAttachmentsEditData = [];
  let attachmentsForDelete = [];
  let caseManagerId;
  let selectedConsumers = [];
  let groupNoteOtherConsumers = [];
  let selectedDate = null;
  let selectedServiceCode;
  let updatedInputs = {};
  let allowGroupNotes = false;
  let defaultServiceCode;
  let confidentialNoteCache = null;
  //--------------------------
  // DOM
  //--------------------------
  let moduleWrap;
  let cnHeader;
  let cnDateNavWrap;
  let cnFormWrap;
  let cnRosterWrap;
  let formEditInfo;
  let groupInfoEle;
  let batchedStatusEle;
  //--------------------------
  // UI INSTANCES
  //--------------------------
  let dateNavigation;
  let rosterPicker;
  let cnForm;
  let cnPhrases;
  let cnDocTimer;
  let cnFormToast;
  let reqVisualizer;
  let unsavedChangesPopup;
  let overlapPopup;
  let deleteConfirmationPopup;

  // UTILS
  //--------------------------------------------------
  async function onModuleExit() {
    if (!notesOverview.isEditing()) {
      return true;
    }

    const unsavedChanged = checkFormForUnsavedChanges();
    let leaveForm = true;

    if (unsavedChanged) {
      const confirmOrCancel = await unsavedChangesPopup.show(
        'Are you sure you want to leave? This note will not be saved.',
      );
      leaveForm = confirmOrCancel === 'confirm' ? true : false;
    }

    return leaveForm;
  }
  function isNoteReadOnly(credit, batched) {
    if (!$.session.CaseNotesUpdate || batched) return true;

    if ($.session.applicationName === 'Gatekeeper') {
      if (
        !$.session.CaseNotesUpdateEntered ||
        ($.session.CaseNotesUpdateEntered && caseManagerId === $.session.PeopleId)
      ) {
        return false;
      } else {
        return true;
      }
    }

    if (credit === 'Y' || credit === '-1') {
      return true;
    } else {
      return false;
    }
  }
  function checkNoteConfidentiality(confidential) {
    if (confidential === 'Y' && caseManagerId !== $.session.PeopleId) {
      confidentialNoteCache = caseNoteEditData.casenote;

      cnForm.inputs['noteText'].setValue('This is a confidential note.');
      cnForm.inputs['noteText'].toggleDisabled(true);
      cnForm.inputs['confidential'].toggleDisabled(true);
    }
  }
  function checkServiceFundingADV() {
    //! ADV ONLY
    // based off selected servBillCode
    // check its service funding value
    // if funding value is "N" - disable service location dropdown
    // else - enable dropdown, make required
  }
  function checkGroupNotesPermission() {
    if ($.session.applicationName === 'Gatekeeper') {
      allowGroupNotes = cnData.allowGroupNotes(selectedServiceCode);
    } else {
      allowGroupNotes = true;
    }

    rosterPicker.toggleMultiSelectOption(allowGroupNotes);
  }
  function extractCaseNoteId(xmlString) {
    const match = xmlString.match(/<caseNoteId>(\d+)<\/caseNoteId>/);
    return match ? match[1] : null;
  }
  function checkRequiredFields() {
    const isFormValid = areRequiredFieldsFilled();
    let isSaveDisabled = false;

    if (selectedConsumers.length === 0 || !isFormValid) {
      isSaveDisabled = true;
    } else {
      isSaveDisabled = false;
    }

    if (isSaveDisabled) {
      cnForm.buttons['submit'].toggleDisabled(true);
      cnForm.buttons['saveAndNew'].toggleDisabled(true);
      cnForm.buttons['update'].toggleDisabled(true);
    } else {
      cnForm.buttons['submit'].toggleDisabled(false);
      cnForm.buttons['saveAndNew'].toggleDisabled(false);
      cnForm.buttons['update'].toggleDisabled(false);
    }
  }

  // TIME HELPERS
  //--------------------------------------------------
  function parseSessionTime(dirtyTime) {
    let time = `${dirtyTime.slice(0, -2)} ${dirtyTime.slice(-2)}`;
    time = UTIL.convertToMilitary(time);
    return time.slice(0, -3);
  }
  function timesWithinWorkHoursCheck(startTime, endTime) {
    const valuesToCheck = [undefined, null, '', '00:00', 'Null'];
    const isWarningStartTimeValid = valuesToCheck.includes($.session.caseNotesWarningStartTime) ? false : true;
    const isWarningEndTimeValid = valuesToCheck.includes($.session.caseNotesWarningStartTime) ? false : true;

    if (!isWarningStartTimeValid || !isWarningEndTimeValid) {
      // session warning times don't matter
      return true;
    }

    const warnStart = parseSessionTime($.session.caseNotesWarningStartTime);
    const warnEnd = parseSessionTime($.session.caseNotesWarningEndTime);

    const validStart = (startTime < warnStart || startTime > warnEnd) && startTime !== '' ? false : true;
    const validEnd = (endTime < warnStart || endTime > warnEnd) && endTime !== '' ? false : true;

    return { validStart, validEnd };
  }
  function isFutureTime(dirtyTime) {
    //If selectedDate is not today then time dosen't matter
    const isToday = new Date().setHours(0, 0, 0, 0) === new Date(selectedDate).setHours(0, 0, 0, 0);
    if (!isToday || !dirtyTime) {
      return false;
    }

    const currentDate = new Date();
    const selectedDateClone = new Date(selectedDate);
      
    // CHECKS IF TIME IS IN FURUTRE
    dirtyTime = dirtyTime.split(':');
    selectedDateClone.setHours(dirtyTime[0], dirtyTime[1], 0, 0);
    return dates.isAfter(selectedDateClone, currentDate);
  }
  function isStartTimeBeforeEndTime(startTime, endTime) {
    if (!startTime || !endTime) return true;

    return startTime < endTime ? true : false;
  }
  async function timeOverlapCheck(startTime, endTime) {
    await cnData.fetchTimeOverlapData({
      caseManagerId,
      consumerId: selectedConsumers[0],
      endTime: endTime,
      groupNoteId: caseNoteGroupId ?? 0,
      noteId: caseNoteId ?? 0,
      serviceDate: dates.formatISO(selectedDate, { representation: 'date' }),
      startTime: startTime,
    });

    const overlap = cnData.getOverlapData();

    return overlap;
  }

  // CRUD
  //--------------------------------------------------
  async function deleteNote(noteId) {
    const response = await _UTIL.fetchData('deleteExistingCaseNote', {
      noteId: noteId,
    });

    return response.deleteExistingCaseNoteResults;
  }
  async function saveAttachments(attachmentsForSave) {
    const saveAttachmentPromises = [];

    // Store promises in array so we can handle each attachment individually
    for (attachment in attachmentsForSave) {
      const promise = _UTIL
        .fetchData('addCaseNoteAttachment', {
          caseNoteId: caseNoteId,
          description: attachmentsForSave[attachment].description,
          attachmentType: attachmentsForSave[attachment].type,
          attachment: attachmentsForSave[attachment].attachment,
        })
        .then(result => ({ status: 'fulfilled', value: result }))
        .catch(error => ({ status: 'rejected', reason: error, attachment: attachmentsForSave[attachment] }));

      saveAttachmentPromises.push(promise);
    }

    // Loop through to check for any failed attachment saves
    const saveAttachmentResults = await Promise.allSettled(saveAttachmentPromises);
    const failedSaves = saveAttachmentResults.reduce((acc, result) => {
      if (result.status === 'rejected') {
        acc.push(result.attachment.description);
      }
      return acc;
    }, []);

    return failedSaves.length === 0 ? 'success' : 'error';
  }
    async function updateGroup(data) {
    for (const consumerId of selectedConsumers) {
      if (caseNoteEditData.consumerid === consumerId) {
        data.consumerId = consumerId;
        //const saveResp = await _UTIL.fetchData('saveCaseNote', data);
        const updateGroupResp = await _UTIL.fetchData('updateGroupNoteValues', {
          groupNoteId: caseNoteGroupId,
          noteId: caseNoteId,
          serviceOrBillingCodeId: data.serviceOrBillingCodeId,
          serviceDate: data.serviceDate,
          startTime: data.startTime,
          endTime: data.endTime,
          caseNote: data.caseNote,
        });
      } else {
        data.consumerId = consumerId;
        data.noteId = 0;
        data.groupNoteId = caseNoteGroupId;
        const saveResp = await _UTIL.fetchData('saveAdditionalGroupCaseNote', data);
        const updateGroupResp = await _UTIL.fetchData('updateGroupNoteValues', {
          groupNoteId: caseNoteGroupId,
          noteId: data.noteId,
          serviceOrBillingCodeId: data.serviceOrBillingCodeId,
          serviceDate: data.serviceDate,
          startTime: data.startTime,
          endTime: data.endTime,
          caseNote: data.caseNote,
        });
      }
    }

    return {
      success: 'success',
      newGroup: false,
    };
  }
  async function saveGroup(data) {
    const savePromises = [];
    let newGroupId;
    let consumerGroupCount;

    // new group save we delete orig case note
    await deleteNote(caseNoteId);
    caseNoteId = null;
    const response = await _UTIL.fetchData('getGroupNoteId');
    const parsednewGroupId = JSON.parse(response.getGroupNoteIdResult);
    newGroupId = parsednewGroupId[0].groupNoteId;
    consumerGroupCount = selectedConsumers.length;

    selectedConsumers.forEach(consumerId => {
      if (data.casenotetraveltime === 'N') {
        data.casenotetraveltime = 0;
      }

      savePromises.push(
        _UTIL
          .fetchData('saveGroupCaseNote', {
            ...data,
            consumerId,
            consumerGroupCount,
            groupNoteId: newGroupId,
            noteId: 0,
          })
          .then(result => ({ status: 'fulfilled', value: result }))
          .catch(error => ({ status: 'rejected', reason: error })),
      );
    });

    const groupSaveResults = await Promise.allSettled(savePromises);
    const failedSaves = groupSaveResults.reduce((acc, result) => {
      if (result.status === 'rejected') {
        acc.push('fail');
      }
      return acc;
    }, []);

    if (!caseNoteGroupId && caseNoteAttachmentsEditData.length) {
      // re saving attachments back to orig note
      saveAttachments(caseNoteAttachmentsEditData);
    }

    const success = failedSaves.length === 0 ? 'success' : 'error';
    return {
      success,
      newGroup: true,
    };
  }
  async function saveNote(data, attachments) {
    let saveResponse,
      isNewGroup = false;

    if (selectedConsumers.length === 1 && !caseNoteGroupId) {
      // NEW NOTE or EDIT NON GROUP NOTE
      const response = (await _UTIL.fetchData('saveCaseNote', data)).saveCaseNoteResult;
      caseNoteId = caseNoteId ? caseNoteId : extractCaseNoteId(response);
      saveResponse = caseNoteId ? 'success' : 'error';
      isNewGroup = false;

      // SAVE ATTACHMENTS
      if ($.session.applicationName === 'Gatekeeper' && Object.keys(attachments).length > 0) {
        const attachSaveResponse = saveAttachments(attachments);
        if (attachSaveResponse === 'error') {
          reqVisualizer.fullfill('error', 'Error Saving Attachments', 2000);
          return;
        }
      }

      return { saveResponse, isNewGroup };
    }

    if (!caseNoteGroupId) {
      const resp = await saveGroup(data);
      saveResponse = resp.success;
      isNewGroup = resp.newGroup;
      return { saveResponse, isNewGroup };
    }

    const resp = await updateGroup(data);
    saveResponse = resp.success;
    isNewGroup = resp.newGroup;
    return { saveResponse, isNewGroup };
  }

  // FORM
  //--------------------------------------------------
  function areRequiredFieldsFilled() {
    // Select all elements that have the "require" attribute.
    const invalidElements = document.querySelectorAll(
      '[data-ui] .inputGroup input:invalid:not(#phrase):not(#shortcut), ' +
        '[data-ui] .inputGroup select:invalid:not(#phrase):not(#shortcut), ' +
        '[data-ui] .inputGroup textarea:invalid:not(#phrase):not(#shortcut)',
    );

    // Check if invalidElements contains #startTime or #endTime
    if (Array.from(invalidElements).some(field => field.id === 'startTime' || field.id === 'endTime')) {
      return false;
    }

    // Check that each field has a non-empty, trimmed value.
    return Array.from(invalidElements).every(field => field.value && field.value.trim() !== '');
  }
  function checkFormForUnsavedChanges() {
    // Return false to stop the action of user leaving form with unsaved changes

    const formData = new FormData(cnForm.form);
    const entries = formData.entries();
    const newNoteData = Object.fromEntries(entries);

    let hasChanged = false;

    if (!caseNoteId) {
      for (const [key, value] of Object.entries(newNoteData)) {
        if (key === 'attachment') continue;

        if (value) {
          hasChanged = true;
          break;
        }
      }
    } else {
      hasChanged = true;
    }

    return hasChanged;
  }
  function toggleFormButtonShowHide() {
    cnForm.buttons['submit'].toggleVisibility(caseNoteId ? true : false);
    cnForm.buttons['saveAndNew'].toggleVisibility(caseNoteId ? true : false);
    //cnForm.buttons['cancel'].toggleVisibility(caseNoteId ? true : false);
    cnForm.buttons['update'].toggleVisibility(caseNoteId ? false : true);
    cnForm.buttons['delete'].toggleVisibility(caseNoteId ? false : true);
  }
  function toggleFormButtonsDisabled(isDisabled) {
    cnForm.buttons['submit'].toggleDisabled(isDisabled);
    cnForm.buttons['saveAndNew'].toggleDisabled(isDisabled);
    cnForm.buttons['update'].toggleDisabled(isDisabled);
    cnForm.buttons['delete'].toggleDisabled(isDisabled);
    cnForm.buttons['clear'].toggleDisabled(isDisabled);
  }
  // DROPDOWNS
  async function updateVendorDropdownByConsumer() {
    await cnData.fetchVendorDropdownData({
      consumerId: selectedConsumers[0],
      serviceDate: dates.formatISO(selectedDate, { representation: 'date' }),
    });

    const vendorData = cnData.getVendorDropdownData();
    cnForm.inputs['vendor'].populate(vendorData);

    if (vendorData.length === 1) {
      cnForm.inputs['vendor'].setValue(vendorData[0].value);
    }
  }
  async function updateServiceLocationDropdownByConsumer() {
    await cnData.fetchServiceLocationDropdownData({
      consumerId: selectedConsumers[0],
      serviceDate: dates.formatISO(selectedDate, { representation: 'date' }),
    });

    const servLocData = cnData.getServiceLocationDropdownData();
    cnForm.inputs['serviceLocation'].populate(servLocData);
    if (!servLocData || servLocData.length === 0) {
      cnForm.inputs['serviceLocation'].toggleDisabled(true);
      cnForm.inputs['serviceLocation'].setValue('');
    }

    if (cnForm.formData) {
      cnForm.inputs['serviceLocation'].setValue(cnForm.formData.serviceLocation);
    }

    onServiceCodeChange();
  }
  async function setConsumerRelatedDropdowns() {
    await updateVendorDropdownByConsumer();

    if ($.session.applicationName === 'Advisor') {
      await updateServiceLocationDropdownByConsumer();

      if (cnData.canConsumerHaveMileage(selectedConsumers[0])) {
        cnForm.inputs['mileage'].toggleDisabled(false);
      }
    }
  }
  // ATTACHMENT DELETE
  async function onFileDelete(e) {
    // console.log(e.target);
    // console.log('File delete from form', e.detail);

    attachmentsForDelete.push(e.detail);
    // console.log(attachmentsForDelete);
  }
  //
  // CHANGE \ KEYUP
  function onTimeChange(target) {
    const inputKey = target === 'start' ? 'startTime' : 'endTime';
    const startTimeVal = cnForm.inputs['startTime'].getValue();
    const endTimeVal = cnForm.inputs['endTime'].getValue();

    // If both fields are empty, no validation needed
    if (startTimeVal === '' && endTimeVal === '') {
      return;
    }

    // Clear all previous errors/warnings first
    cnForm.inputs['startTime'].setValidtyError('');
    cnForm.inputs['endTime'].setValidtyError('');
    cnForm.inputs['startTime'].clearErrorOrWarning();
    cnForm.inputs['endTime'].clearErrorOrWarning();

    let hasValidationErrors = false;

    // Future time validation - ALWAYS check both times when they have values
    // This ensures that existing future time errors don't get cleared incorrectly
    if (startTimeVal && startTimeVal !== '') {
      const isStartTimeFuture = isFutureTime(startTimeVal);
      if (isStartTimeFuture) {
        cnForm.inputs['startTime'].setValidtyError('error');
        cnForm.inputs['startTime'].showError('Time cannot be in the future.');
        hasValidationErrors = true;
      }
    }

    if (endTimeVal && endTimeVal !== '') {
      const isEndTimeFuture = isFutureTime(endTimeVal);
      if (isEndTimeFuture) {
        cnForm.inputs['endTime'].setValidtyError('error');
        cnForm.inputs['endTime'].showError('Time cannot be in the future.');
        hasValidationErrors = true;
      }
    }

    // Start/End time comparison - only if both times exist and no future time errors
    if (startTimeVal && endTimeVal && !hasValidationErrors) {
      const isStartBeforeEnd = isStartTimeBeforeEndTime(startTimeVal, endTimeVal);
      if (!isStartBeforeEnd) {
        cnForm.inputs['startTime'].setValidtyError(`error`);
        cnForm.inputs['startTime'].showError(`Start time can't be after end time.`);
        hasValidationErrors = true;
      }
    }

    // Stop here if there are any validation errors
    if (hasValidationErrors) {
      return;
    }

    // Working hours validation (only runs if no errors above)
    let validStart = true;
    let validEnd = true;

    if ($.session.applicationName === 'Gatekeeper' && startTimeVal && endTimeVal) {
      ({ validStart, validEnd } = timesWithinWorkHoursCheck(startTimeVal, endTimeVal));

      if (!validStart) {
        cnForm.inputs['startTime'].showWarning(`Time is outside normal working hours.`);
      }

      if (!validEnd) {
        cnForm.inputs['endTime'].showWarning(`Time is outside normal working hours.`);
      }
    }
    if (!hasValidationErrors) {
      if (validStart) {
        cnForm.inputs['startTime'].clearErrorOrWarning();
      }
      if (validEnd) {
        cnForm.inputs['endTime'].clearErrorOrWarning();
      }
    }
  }
  function onServiceCodeChange(documentationTime = 0) {
    if (caseNoteId) {
      checkGroupNotesPermission();
    }

    if ($.session.applicationName === 'Gatekeeper' && selectedServiceCode !== '') {
      const mileageRequired = cnData.isMileageRequired(selectedServiceCode);
      const isTravelTimeRequired = cnData.isTravelTimeRequired(selectedServiceCode);
      const isDocTimeRequired = cnData.isDocTimeRequired(selectedServiceCode);

      if (isDocTimeRequired) {
        cnDocTimer.showAutoStartPopup(parseInt(documentationTime));
      }

      cnForm.inputs['mileage'].toggleDisabled(!mileageRequired);
      cnForm.inputs['travelTime'].toggleDisabled(!isTravelTimeRequired);
    } else {
      const isServiceFunding = cnData.isServiceFunding(selectedServiceCode);
      const servLocData = cnData.getServiceLocationDropdownData();
      const hasServiceLocationData = servLocData && servLocData.length > 0;
      const shouldEnable = isServiceFunding && hasServiceLocationData;
      cnForm.inputs['serviceLocation'].toggleDisabled(!shouldEnable);
      cnForm.inputs['serviceLocation'].toggleRequired(isServiceFunding);
      if (!shouldEnable) {
        cnForm.inputs['serviceLocation'].setValue('');
      }
    }

    if (selectedServiceCode !== '') {
      // get required fields
      const locationRequired = cnData.isLocationRequired(selectedServiceCode);
      const needRequired = cnData.isNeedRequired(selectedServiceCode);
      const contactRequired = cnData.isContactRequired(selectedServiceCode);
      const serviceRequired = cnData.isServiceRequired(selectedServiceCode);
      // enable dropdowns
      cnForm.inputs['location'].toggleDisabled(!locationRequired);
      cnForm.inputs['service'].toggleDisabled(!serviceRequired);
      cnForm.inputs['need'].toggleDisabled(!needRequired);
      cnForm.inputs['contact'].toggleDisabled(!contactRequired);
      // set required fields
      cnForm.inputs['location'].toggleRequired(locationRequired);
      cnForm.inputs['service'].toggleRequired(serviceRequired);
      cnForm.inputs['need'].toggleRequired(needRequired);
      cnForm.inputs['contact'].toggleRequired(contactRequired);
      //populate dropdowns tied to this one
      cnForm.inputs['location'].populate(cnData.getLocationDropdownData(selectedServiceCode));
      cnForm.inputs['service'].populate(cnData.getServicesDropdownData(selectedServiceCode));
      cnForm.inputs['need'].populate(cnData.getNeedsDropdownData(selectedServiceCode));
      cnForm.inputs['contact'].populate(cnData.getContactsDropdownData(selectedServiceCode));
    } else {
      // set required to false
      cnForm.inputs['location'].toggleRequired(false);
      cnForm.inputs['service'].toggleRequired(false);
      cnForm.inputs['need'].toggleRequired(false);
      cnForm.inputs['contact'].toggleRequired(false);
      // disable dropdowns
      cnForm.inputs['location'].toggleDisabled(true);
      cnForm.inputs['service'].toggleDisabled(true);
      cnForm.inputs['need'].toggleDisabled(true);
      cnForm.inputs['contact'].toggleDisabled(true);
      //clear dropdown values
      cnForm.inputs['location'].populate([]);
      cnForm.inputs['service'].populate([]);
      cnForm.inputs['need'].populate([]);
      cnForm.inputs['contact'].populate([]);
    }
  }
  const onChangeCallbacks = {
    serviceCode: ({ event, value, name, input }) => {
      selectedServiceCode = value;
      onServiceCodeChange();
    },
    serviceLocation: ({ event, value, name, input }) => {
      // adv only
    },
    startTime: () => {
      onTimeChange('start');
    },
    endTime: () => {
      onTimeChange('end');
    },
    mileage: ({ event, value, name, input }) => {
      return;

      const hasDecimal = event.key === '.' && value.indexOf('.') === 1 ? true : false;
    },
  };
  function onFormChange(event) {
    const value = event.target.value;
    let name = event.target.name;
    const input = cnForm.inputs[name];

    if (onChangeCallbacks[name]) {
      onChangeCallbacks[name]({
        event,
        value,
        name,
        input,
      });
    }

    checkRequiredFields();
  }
  const onKeyupCallbacks = {
    travelTime: ({ event, value, name, input }) => {
      if (value.length > 4) {
        event.target.value = value.substr(0, 4);
      }
    },
    /**
     * @param {Object} data
     * @param {Event} data.event - event obj
     * @param {string} data.value - value of input
     * @param {Event} data.name - name of input
     * @param {Instance} data.input - noteText input instance
     */
    noteText: ({ event, value, name, input }) => {
      const words = value.split(/\s+/);

      if (event.detail) {
        // check for the #ph
        if (words.includes('#ph')) {
          // if (cnPhrases.InsertPhrases.dialog.dialog.parentNode !== input.fullscreen.fullScreenDialog.dialog) {
          //   cnPhrases.InsertPhrases.renderTo(input.fullscreen.fullScreenDialog.dialog);
          // }

          // get textarea clone in fullscreen popup
          const textareaInput = input.fullscreen.textareaClone.querySelector('textarea');

          // disable textarea and close buton
          textareaInput.disabled = true;
          input.fullscreen.disableCloseButon(true);

          // show phrases dialog
          cnPhrases.InsertPhrases.show();

          cnPhrases.InsertPhrases.onPhraseSelect(phraseText => {
            // Replace #ph with user-generated text
            const textValue = value.replace('#ph', phraseText);
            // Update the textarea's value
            input.setValue(textValue);
            textareaInput.value = textValue;
            // re enable input
            textareaInput.disabled = false;
            // close dialog
            cnPhrases.InsertPhrases.close();
            // disable textarea and close buton
            textareaInput.disabled = false;
            input.fullscreen.disableCloseButon(false);
            // focus on textarea
            textareaInput.focus();
          });
        }
      } else {
        // check for the #ph
        if (words.includes('#ph')) {
          // temp disable input

          // #114862 - SH-ANY-CN: Add new phrase pop-up cancel button doesn't work
          // input.toggleDisabled(true);
          ////

          // show phrases dialog
          cnPhrases.InsertPhrases.show();

          cnPhrases.InsertPhrases.onPhraseSelect(phraseText => {
            // Replace #ph with user-generated text
            const textValue = value.replace('#ph', phraseText);
            // Update the textarea's value
            input.setValue(textValue);
            input.fullscreen.updateCloneValue(textValue);
            // re enable input
            input.toggleDisabled(false);
            // close dialog
            cnPhrases.InsertPhrases.close();
            // focus on textarea
            input.setFocus();
          });
        }
      }
    },
  };
  function onFormKeyup(event) {
    const value = event.target.value;
    let name = event.target.name;
    const input = cnForm.inputs[name];

    if (onKeyupCallbacks[name]) {
      onKeyupCallbacks[name]({
        event,
        value,
        name,
        input,
      });
    }

    checkRequiredFields();
  }
  // EDIT
  function setGroupInfo(groupData, noteId, selectedConsumerId) {
    if (!groupData[noteId]) {
      groupInfoEle.innerHTML = '';
      groupNoteOtherConsumers = [];
      return;
    }

    const groupNoteData = Object.entries(groupData[noteId]);

    if (groupNoteData.length === 0) {
      groupInfoEle.innerHTML = '';
      groupNoteOtherConsumers = [];
      return;
    }

    let groupConsumers = 'Other consumers part of this group';
    groupNoteOtherConsumers = [];

    groupNoteData.forEach(([id, name]) => {
      if (id !== selectedConsumerId) {
        groupConsumers += ` | ${name} `;
        groupNoteOtherConsumers.push(id);
      }
    });

    groupInfoEle.innerHTML = `<p>${groupConsumers}</p>`;
  }
  function updateLastEditedByLastEditDate({ editedBy, editedOn }) {
    formEditInfo.innerHTML = '';

    const lastEditOn = _DOM.createElement('p', {
      text: `Last Edited On: ${editedOn}`,
    });
    const lastEditBy = _DOM.createElement('p', {
      text: `Entered By: ${editedBy}`,
    });

    formEditInfo.appendChild(lastEditOn);
    formEditInfo.appendChild(lastEditBy);
  }
  function getReviewText(reviewResult) {
    if (reviewResult === 'N') {
      return 'Not Reviewed';
    }
    if (reviewResult === 'P') {
      return 'Passed';
    }
    if (reviewResult === 'R') {
      return 'Rejected';
    }

    return reviewResult;
  }
  function showNoteReviewStatus({ reviewResult, rejectionReason }) {
    const showRejectionReason =
      $.session.applicationName === 'Gatekeeper' && reviewResult === 'R' && rejectionReason !== '';

    const reviewStatusNote = `
      <div class="reviewStatusInfo">
        <p>Review Required for this Case Note.</p>
        <p>Review Results: ${getReviewText(reviewResult)}</p>
        ${showRejectionReason ? `<p>Rejection Reason: ${rejectionReason}</p>` : ''}
      </div>
    `;

    cnForm.inputs['corrected'].toggleVisibility(false);
    cnForm.inputs['corrected'].updateNote(reviewStatusNote);

    if ($.session.applicationName === 'Advisor' || reviewResult !== 'R') {
      // hide the checkbox but leave cnForm.inputs['corrected'] visible to show note text
      cnForm.inputs['corrected'].input.style.display = 'none';
      cnForm.inputs['corrected'].labelEle.style.display = 'none';
    }
  }
  function showBatchedStatus(batchedStatus) {
    if (batchedStatus) {
      //batchedStatusEle.style.display = 'block';
      batchedStatusEle.innerHTML = 'Case Note is Batched';
    } else {
      //batchedStatusEle.style.display = 'none';
      batchedStatusEle.innerHTML = '';
    }
  }
  async function populateForm(noteId, groupData) {
    cnForm.disableFormInputs(false);
    toggleFormButtonsDisabled(false);
    rosterPicker.toggleRosterDisabled(false);
    dateNavigation.disableNav(false);
    if ($.session.applicationName === 'Gatekeeper') {
      cnDocTimer.disable(false);
    }

    let data = await _UTIL.fetchData('getCaseNoteEditJSON', {
      noteId: noteId,
    });
    caseNoteEditData = data.getCaseNoteEditJSONResult[0];

    caseNoteId = noteId;
    servicedate = caseNoteEditData.servicedate.split(' ')[0];
    caseNoteGroupId = caseNoteEditData.groupid;
    caseManagerId = caseNoteEditData.casemanagerid;
    selectedServiceCode = caseNoteEditData.mainbillingorservicecodeid;
    selectedConsumers = [caseNoteEditData.consumerid];
    attachmentsForDelete = [];

    selectedDate = new Date(servicedate);
    dateNavigation.setDate(selectedDate);

    await setConsumerRelatedDropdowns();
    onServiceCodeChange(caseNoteEditData.totaldoctime);

    cnForm.populate({
      serviceCode: caseNoteEditData.mainbillingorservicecodeid,
      location: caseNoteEditData.locationcode,
      serviceLocation: caseNoteEditData.servicelocationid,
      service: caseNoteEditData.servicecode,
      need: caseNoteEditData.serviceneedcode,
      vendor: caseNoteEditData.vendorid,
      contact: caseNoteEditData.contactcode,
      startTime: caseNoteEditData.starttime,
      endTime: caseNoteEditData.endtime,
      mileage: caseNoteEditData.totalmiles,
      travelTime: caseNoteEditData.traveltime,
      noteText: caseNoteEditData.casenote,
      confidential: caseNoteEditData.confidential === 'Y' ? true : false,
      corrected: caseNoteEditData.corrected === 'Y' ? true : false,
      outcomeServiceMonitoring: caseNoteEditData.outcomeServiceMonitoring === 'Y' ? true : false,
    });

    if ($.session.applicationName === 'Gatekeeper') {
      await cnData.fetchAttachmentsGK(caseNoteId);
      caseNoteAttachmentsEditData = cnData.getAttachmentsList();
      cnForm.inputs['attachment'].addAttachments(caseNoteAttachmentsEditData);
    }

    setGroupInfo(groupData, caseNoteEditData.groupid, caseNoteEditData.consumerid);
    showBatchedStatus(caseNoteEditData.batched);
    updateLastEditedByLastEditDate({
      editedBy: `${caseNoteEditData.originaluserid} (${caseNoteEditData.originaluserfullname})`,
      editedOn: caseNoteEditData.lastupdate,
    });

    if (caseNoteEditData.reviewrequired === 'Y') {
      showNoteReviewStatus({
        reviewResult: caseNoteEditData.reviewresults,
        rejectionReason: caseNoteEditData.rejectionreason,
      });
    }

    toggleFormButtonShowHide();
    checkRequiredFields();
    checkNoteConfidentiality(confidential);

    rosterPicker.setSelectedConsumers(selectedConsumers, true);
    rosterPicker.setDisabledConsumers(groupNoteOtherConsumers);

    const isNoteBatched = caseNoteEditData.batched !== '' ? true : false;
    if (isNoteReadOnly(caseNoteEditData.credit, isNoteBatched)) {
      cnForm.disableFormInputs();
      toggleFormButtonsDisabled(true);
      rosterPicker.toggleRosterDisabled(true, true);
      dateNavigation.disableNav(true);
      if ($.session.applicationName === 'Gatekeeper') {
        cnDocTimer.disable(true);
      }
    }
  }
  // SUBMIT
  async function processAttachmentsForSave(data) {
    const attachmentsForSave = {};

    for (const key in data) {
      if (key.includes('attachment')) {
        if (data[key].name) {
          const attachmentDetails = await _DOM.getAttachmentDetails(data[key]);
          attachmentsForSave[attachmentDetails.description] = attachmentDetails;
        }
      }
    }

    return attachmentsForSave;
  }
  async function submitFormData(data) {
    const overlaps = await timeOverlapCheck(data.startTime, data.endTime);
    if (overlaps.length) {
      const continueSave = await overlapPopup.show(
        `The times you have entered for this note overlap with the following consumer(s), ${overlaps.join(
          ',',
        )}. Click OK to continue with save or CANCEL to go back to note.`,
      );

      if (continueSave === 'cancel') {
         return 'cancel';
      }
    }

    // Fetch reviewRequired data
    const reviewRequiredData = await cnData.fetchCaseManagerReviewData(caseManagerId);

    if (confidentialNoteCache) {
      data.noteText = confidentialNoteCache;
      confidentialNoteCache = null;
    }

    const saveData = {
      caseManagerId,
      caseNote: data.noteText ? _UTIL.removeUnsavableNoteText(data.noteText) : '',
      casenotemileage: data.mileage ?? '0',
      casenotetraveltime: data.travelTime ?? '',
      consumerId: selectedConsumers[0],
      confidential: data.confidential === 'on' ? 'Y' : 'N',
      contactCode: data.contact ?? '',
      corrected: data.corrected === 'on' ? 'Y' : 'N',
      documentationTime: $.session.applicationName === 'Gatekeeper' ? cnDocTimer.stop().getTime() : '',
      endTime: data.endTime.substring(0, 5),
      locationCode: data.location ?? '',
      noteId: caseNoteId ?? 0,
      needCode: data.need ?? '',
      reviewRequired: reviewRequiredData.reviewRequired,
      serviceDate: dates.formatISO(selectedDate, { representation: 'date' }),
      serviceCode: data.service ?? '',
      serviceLocationCode: data.serviceLocation ?? '',
      serviceOrBillingCodeId: data.serviceCode ?? '',
      startTime: data.startTime.substring(0, 5),
      vendorId: data.vendor ?? '',
      outcomeServiceMonitoring: data.outcomeServiceMonitoring === 'on' ? 'Y' : 'N',
    };
    const attachmentsForSave = await processAttachmentsForSave(data);

    const { saveResponse } = await saveNote(saveData, attachmentsForSave);

    return saveResponse;
  }
  async function onFormCancel() {
    const unsavedChanged = checkFormForUnsavedChanges();
    let leaveForm = true;

    if (unsavedChanged) {
      const confirmOrCancel = await unsavedChangesPopup.show(
        'Are you sure you want to Cancel? Any unsaved changes will be lost.',
      );
      leaveForm = confirmOrCancel === 'confirm' ? true : false;
    }

    if (leaveForm) {
      if (formCancelCallback) {
        resetNoteData();
        cnForm.clear();
        cnFormToast.close();
        rosterPicker.setSelectedConsumers([]);
        rosterPicker.setDisabledConsumers([]);
        formCancelCallback();
      } else {
        resetModule();
        caseNotes.load();
      }
    }
  }
  async function onFormReset() {
    const unsavedChanged = checkFormForUnsavedChanges();
    let clearForm = true;

    if (unsavedChanged) {
      const confirmOrCancel = await unsavedChangesPopup.show(
        'Are you sure you want to remove all data from this case note?',
      );
      clearForm = confirmOrCancel === 'confirm' ? true : false;
    }

    if (clearForm) {
      resetNoteData();
      cnForm.clear();
      cnFormToast.close();
      rosterPicker.setSelectedConsumers([]);
      rosterPicker.setDisabledConsumers([]);
      checkRequiredFields();

      if ($.session.applicationName === 'Gatekeeper') {
        cnDocTimer.clear();
      }

      if (formResetCallback) {
        formResetCallback();
      }
    }
  }
  async function onFormDelete() {
    const continueSave = await deleteConfirmationPopup.show('Are you sure you would like to delete this case note?');

    if (continueSave !== 'confirm') {
      return;
    }

    await deleteNote(caseNoteId);

    resetNoteData();
    cnForm.clear();
    cnFormToast.close();
    rosterPicker.setSelectedConsumers([]);
    rosterPicker.setDisabledConsumers([]);

    if ($.session.applicationName === 'Gatekeeper') {
      cnDocTimer.clear();
    }

    if (formDeleteCallback) {
      formDeleteCallback();
    }
  }
  async function onFormSubmit(data, submitter) {
    reqVisualizer.show('Saving Case Note...');

    toggleFormButtonsDisabled(true);
    const buttonName = submitter.name.toLowerCase();

    const saveResponse = await submitFormData(data);

        if (saveResponse === 'cancel') {
            toggleFormButtonsDisabled(false);
            cnFormToast.close();
            reqVisualizer.hide();
            return;
        }
    if (saveResponse === 'success') {
      reqVisualizer.fullfill('success', 'Case Note Saved!', 2000);
    } else {
      reqVisualizer.fullfill('error', 'Error Saving Case Note', 2000);
    }

    setTimeout(() => {
      cnFormToast.close();

      if (buttonName === 'saveandnew') {
        resetNoteData();
        cnForm.clear();
        rosterPicker.setSelectedConsumers([]);
        rosterPicker.setDisabledConsumers([]);
        cnForm.inputs['serviceCode'].setValue(selectedServiceCode);
        onServiceCodeChange();

        if ($.session.applicationName === 'Gatekeeper') {
          cnDocTimer.clear();
        }
      } else {
        toggleFormButtonsDisabled(false);

        if (formSaveCallback) {
          formSaveCallback();
        } else {
          notesOverview.init();
        }
      }
    }, 1000);
  }

  // ROSTER
  //--------------------------------------------------
  async function onConsumerSelect(data) {
    selectedConsumers = data;

    await updateVendorDropdownByConsumer();

    if ($.session.applicationName === 'Advisor') {
      if (cnData.canConsumerHaveMileage(selectedConsumers[0])) {
        cnForm.inputs['mileage'].toggleDisabled(false);
      }

      await updateServiceLocationDropdownByConsumer();
      const servLocData = cnData.getServiceLocationDropdownData();
      if (!servLocData || servLocData.length === 0) {
        cnForm.inputs['serviceLocation'].toggleDisabled(true);
        cnForm.inputs['serviceLocation'].setValue('');
      }
    }

    checkRequiredFields();
  }

  // DATE NAV
  //--------------------------------------------------
  async function onDateChange(newDate) {
    selectedDate = newDate;

    onTimeChange();

    await rosterPicker.fetchConsumers(selectedDate);
    rosterPicker.populate();

    selectedConsumers.forEach(consumerId => {
      if (caseNoteEditData && caseNoteEditData.consumerid === consumerId) {
        rosterPicker.toggleConsumerSelectedById(consumerId, true, true);
      } else {
        rosterPicker.toggleConsumerSelectedById(consumerId, true, false);
      }
    });
  }

  // PAGE
  //--------------------------------------------------
  function attachEvents() {
    dateNavigation.onDateChange(onDateChange);
    rosterPicker.onConsumerSelect(onConsumerSelect);
    cnForm.onChange(onFormChange);
    cnForm.onKeyup(onFormKeyup);
    cnForm.onDelete(onFormDelete);
    cnForm.onSubmit(onFormSubmit);
    cnForm.onReset(onFormReset);
    cnForm.onCancel(onFormCancel);
    cnForm.onFileDelete(onFileDelete);

    // OVERVIEW // cnOverview.onCardEdit(onOverviewCardEdit);
    // OVERVIEW // cnOverview.onCardDelete(onOverviewCardDelete);
  }
  async function populatePage() {
    await cnPhrases.InsertPhrases.fetchData();
    cnPhrases.InsertPhrases.populate();

    await rosterPicker.fetchConsumers();
    rosterPicker.populate();

    if (selectedConsumers) {
      rosterPicker.setSelectedConsumers(selectedConsumers);
      rosterPicker.setDisabledConsumers([]);
    }
  }
  function buildPage() {
    // build DOM skeleton
    moduleWrap = _DOM.createElement('div', { class: 'caseNotesModule' });
    cnHeader = _DOM.createElement('div', { class: 'caseNotesHeader', html: `<h1>Case Notes</h1>` });
    cnDateNavWrap = _DOM.createElement('div', { class: 'caseNotesDateNav' });
    cnFormWrap = _DOM.createElement('div', { class: 'caseNotesForm' });
    cnRosterWrap = _DOM.createElement('div', { class: 'caseNotesRosterPicker' });
    batchedStatusEle = _DOM.createElement('div', { class: 'formBatchedStatus' });
    groupInfoEle = _DOM.createElement('div', { class: 'formBatchedStatus' });
    formEditInfo = _DOM.createElement('div', { class: 'formEditInfo' });

    if ($.session.applicationName === 'Gatekeeper' && cnDocTimer) {
      cnDocTimer.renderTo(cnFormWrap);
    }

    moduleWrap.appendChild(cnHeader);
    moduleWrap.appendChild(cnDateNavWrap);
    moduleWrap.appendChild(cnRosterWrap);
    moduleWrap.appendChild(cnFormWrap);

    // render UI
    dateNavigation.renderTo(cnDateNavWrap);
    rosterPicker.renderTo(cnRosterWrap);
    cnFormToast.renderTo(cnFormWrap);
    cnFormWrap.appendChild(batchedStatusEle);
    cnFormWrap.appendChild(groupInfoEle);
    cnForm.renderTo(cnFormWrap);
    cnFormWrap.appendChild(formEditInfo);

    cnPhrases.renderTo(_DOM.ACTIONCENTER);
    reqVisualizer.renderTo(_DOM.ACTIONCENTER);
    overlapPopup.renderTo(_DOM.ACTIONCENTER);
    deleteConfirmationPopup.renderTo(_DOM.ACTIONCENTER);
    unsavedChangesPopup.renderTo(_DOM.ACTIONCENTER);
    // missingRequiredFieldsPopup.renderTo(_DOM.ACTIONCENTER);

    attachEvents();

    return moduleWrap;
  }
  function initComponents() {
    // Date Navigation
    dateNavigation = new DateNavigation({
      selectedDate: selectedDate,
      allowFutureDate: false,
    });

    // Roster Picker
    rosterPicker = new RosterPicker({
      allowMultiSelect: false,
      consumerRequired: true,
      selectionDate: undefined,
    });

    // Form
    cnForm = new Form({
      showClearButton: true,
      fields: [
        //confidential
        {
          type: 'checkbox',
          label: 'Confidential',
          id: 'confidential',
        },
        //outcomeServiceMonitoring
        {
          type: 'checkbox',
          label: 'Outcome/Service Monitoring',
          id: 'outcomeServiceMonitoring',
          hidden: $.session.applicationName === 'Advisor',
        },
        //startTime
        {
          type: 'time',
          label: 'Start Time',
          id: 'startTime',
          required: true,
        },
        //endTime
        {
          type: 'time',
          label: 'End Time',
          id: 'endTime',
          required: true,
        },
        //serviceCode
        {
          type: 'select',
          label: $.session.applicationName === 'Gatekeeper' ? 'Bill Code:' : 'Serv. Code:',
          id: 'serviceCode',
          required: true,
          data: cnData.getServiceBillCodeDropdownData(),
          defaultValue: selectedServiceCode,
          includeBlankOption: true,
        },
        //location
        {
          type: 'select',
          label: 'Location',
          id: 'location',
          disabled: true,
          includeBlankOption: true,
        },
        //service
        {
          type: 'select',
          label: 'Service',
          id: 'service',
          disabled: true,
          includeBlankOption: true,
        },
        //need
        {
          type: 'select',
          label: 'Need',
          id: 'need',
          disabled: true,
          includeBlankOption: true,
        },
        //contact
        {
          type: 'select',
          label: 'Contact',
          id: 'contact',
          disabled: true,
          includeBlankOption: true,
        },
        //vendor
        {
          type: 'select',
          label: 'Vendor',
          id: 'vendor',
          note: 'Requires a consumer(s) to be selected',
        },
        //serviceLocation
        {
          type: 'select',
          label: 'Service Location',
          id: 'serviceLocation',
          hidden: $.session.applicationName === 'Gatekeeper',
          disabled: true,
        },
        //noteText
        {
          type: 'textarea',
          label: 'Note',
          id: 'noteText',
          required: true,
          fullscreen: true,
          speechToText: true,
          note: `Use the new quick insert key for phrases, type #ph. (#ph must not be a part of another word)`,
        },
        //mileage
        {
          type: 'number',
          label: 'Mileage',
          id: 'mileage',
          disabled: $.session.applicationName === 'Gatekeeper' ? true : false,
        },
        //travelTime
        {
          type: 'number',
          label: 'Travel Time',
          id: 'travelTime',
          hidden: $.session.applicationName === 'Advisor',
          disabled: true,
        },
        //attachment
        {
          type: 'attachment',
          label: 'Add Attachment',
          id: 'attachment',
          hidden: $.session.applicationName === 'Advisor',
        },
        //corrected
        {
          type: 'checkbox',
          label: 'Corrected',
          id: 'corrected',
          hidden: true,
        },
      ],
      buttons: [
        {
          type: 'submit',
          text: 'Save & New',
          icon: 'add',
          name: 'saveAndNew',
          style: 'primary',
          styleType: 'outlined',
        },
        {
          type: 'submit',
          text: 'Update',
          icon: 'save',
          name: 'update',
          hidden: true,
        },
      ],
    });

    cnForm.buttons['submit'].toggleDisabled(true);
    cnForm.buttons['saveAndNew'].toggleDisabled(true);
    cnForm.buttons['update'].toggleDisabled(true);

    cnFormToast = new Toast();

    // Overview Cards
    cnOverview = new CaseNotesOverview(cnData);

    // Phrases
    cnPhrases = new CaseNotesPhrases();

    // Documentation Timer
    if ($.session.applicationName === 'Gatekeeper') {
      cnDocTimer = new CaseNotesTimer();
    }

    // Req Visualizer
    reqVisualizer = new AsyncRequestVisualizer();

    // Overlap Popup
    overlapPopup = new ConfirmationPopup({ className: 'overlapWarning' });

    // DeleteConfirmation Popup
    deleteConfirmationPopup = new WarningPopup({ className: 'deleteCaseWarning' });

    // Unsaved Changed Warning
    unsavedChangesPopup = new WarningPopup({
      className: 'unsavedChangesWarning',
      confirmText: 'Yes',
      cancelText: 'No',
    });

    // missingRequiredFieldsPopup = new WarningPopup({
    //   className: 'missingFields',
    //   confirmText: 'Yes',
    //   cancelText: 'No',
    // });
  }

  // AS COMPONENT
  //--------------------------------------------------
  let formResetCallback, formDeleteCallback, formSaveCallback, formCancelCallback;
  function setFormResetCallback(callback) {
    formResetCallback = callback;
  }
  function setFormDeleteCallback(callback) {
    formDeleteCallback = callback;
  }
  function setFormSaveCallback(callback) {
    formSaveCallback = callback;
  }
  function setFormCancelCallback(callback) {
    formCancelCallback = callback;
  }
  async function getPage() {
    resetModule();

    initComponents();

    const pageEle = buildPage();

    await populatePage();

    return pageEle;
  }

  // AS PAGE
  //--------------------------------------------------
  async function loadPage({ fromDashboard = false } = {}) {
    resetModule();

    if (fromDashboard === true) {
      selectedConsumers = [CN_CaseLoadWidget.getCurrentlyselectedConsumerId()];
    }

    // prep actioncenter
    _DOM.ACTIONCENTER.innerHTML = '';
    _DOM.ACTIONCENTER.setAttribute('data-UI', true);
    setActiveModuleAttribute('casenotes2.0');
    setActiveModuleSectionAttribute('caseNotes-main');

    initComponents();

    const pageEle = buildPage();
    _DOM.ACTIONCENTER.appendChild(pageEle);

    await populatePage();

    onServiceCodeChange();
    checkRequiredFields();
  }

  // MAIN
  //--------------------------------------------------
  function resetModuleData() {
    moduleWrap = undefined;
    cnHeader = undefined;
    cnDateNavWrap = undefined;
    cnFormWrap = undefined;
    cnRosterWrap = undefined;
    formEditInfo = undefined;
    groupInfoEle = undefined;
    batchedStatusEle = undefined;
    // instances
    dateNavigation = undefined;
    rosterPicker = undefined;
    cnForm = undefined;
    cnOverview = undefined;
    cnPhrases = undefined;
    cnDocTimer = undefined;
    reqVisualizer = undefined;
    unsavedChangesPopup = undefined;
    overlapPopup = undefined;
    deleteConfirmationPopup = undefined;

    formResetCallback = undefined;
    formDeleteCallback = undefined;
    formSaveCallback = undefined;
    formCancelCallback = undefined;
  }
  function resetNoteData() {
    caseNoteId = null;
    caseNoteGroupId = null;
    caseNoteEditData = null;
    caseNoteAttachmentsEditData = [];
    attachmentsForDelete = [];
    caseManagerId = $.session.PeopleId;
    selectedConsumers = [];
    //selectedDate = dates.getTodaysDateObj();
    selectedServiceCode = defaultServiceCode ? defaultServiceCode : '';
    updatedInputs = {};
    allowGroupNotes = false;
    confidentialNoteCache = null;

    if (cnForm) {
      cnForm.inputs['corrected'].toggleVisibility(true);
    }
  }
  async function resetModule() {
    resetModuleData();
    resetNoteData();
  }
  function setPermissions() {
    //! GK ONLY
    //? If note is batched then we shouldn't hit this if bc note is read only
    if ($.session.applicationName === 'Gatekeeper') {
      if ($.session.CaseNotesUpdate) {
        if (
          !$.session.CaseNotesUpdateEntered ||
          ($.session.CaseNotesUpdateEntered && caseManagerId === $.session.PeopleId)
        ) {
          //can edit (correct alignment of Update and UpdateEntered Case Notes permissions)
          isReadOnly = false;
        } else {
          //can not edit (with UpdateEntered permission, can't edit other people's case notes)
          isReadOnly = true;
        }
      } else {
        isReadOnly = true; //can not edit (no overall update permission)
      }
    }
  }
  function afterLoadCheck() {
    onServiceCodeChange();
    checkRequiredFields();
  }
  async function init() {
    setPermissions();

    selectedDate = dates.getTodaysDateObj();
    caseManagerId = $.session.PeopleId;

    // init case notes data
    cnData = new CaseNotesData();
    await cnData.fetchDropdownData();
    await cnData.fetchCaseManagerReviewData(caseManagerId);
    if ($.session.applicationName === 'Advisor') {
      await cnData.fetchConsumersThatCanHaveMileage();
    }

    defaultServiceCode = cnData.getDefaultServiceCode();
    selectedServiceCode = defaultServiceCode;
  }

  return {
    init,
    loadPage,
    afterLoadCheck,
    resetModule,
    getPage,
    setFormResetCallback,
    setFormDeleteCallback,
    setFormSaveCallback,
    setFormCancelCallback,
    populateForm,
    onModuleExit,
  };
})();
